export default __webpack_public_path__ + "static/media/estrella.d4d11dcc.svg";